import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"white-space":"pre-line"} }
const _hoisted_2 = {
  key: 1,
  style: {"white-space":"pre-line"},
  class: "mb-0"
}

import { ref, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  setup(__props, { expose: __expose }) {

const viewModel = reactive({
  showConfirmation: false,
  checkOption: false,
  title: "",
  question: "",
  showCheckOption: true,
  okButtonText: "OK",
  cancelButtonText: "Cancel"
});

const confirmationModal = ref();

function getConfirmation(
  title: string,
  question: string,
  showCheckOption: boolean = true,
  okButtonText: string = "OK",
  cancelButtonText: string = "Cancel"
): Promise<boolean> {
  viewModel.showConfirmation = true;
  viewModel.title = title;
  viewModel.question = question;
  viewModel.checkOption = false;
  viewModel.showCheckOption = showCheckOption;
  viewModel.okButtonText = okButtonText;
  viewModel.cancelButtonText = cancelButtonText;

  return new Promise<boolean>((accept, reject) => {
    const acceptHandler = () => {
      // We need to show other modal dialogs in after closing this dialog
      // but nextTick is not delaying until the dialog is properly hidden.
      // So using the setTimeout as a workaround.
      setTimeout(() => {
        accept(viewModel.checkOption);
      }, 10);
      confirmationModal.value?.hide();
      confirmationModal.value?.$off("ok", acceptHandler);
    };

    const rejectHandler = () => {
      reject();
      confirmationModal.value?.hide();
      confirmationModal.value?.$off("cancel", rejectHandler);
      confirmationModal.value?.$off("close", rejectHandler);
    };

    confirmationModal.value?.$on("ok", acceptHandler);
    confirmationModal.value?.$on("cancel", rejectHandler);
    confirmationModal.value?.$on("close", rejectHandler);
  });
}

__expose({
  getConfirmation: getConfirmation
});

return (_ctx: any,_cache: any) => {
  const _component_b_checkbox = _resolveComponent("b-checkbox")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    "header-close-content": "",
    id: "confirm-modal",
    ref_key: "confirmationModal",
    ref: confirmationModal,
    modelValue: viewModel.showConfirmation,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((viewModel.showConfirmation) = $event)),
    title: viewModel.title,
    "no-close-on-backdrop": "",
    "no-close-on-esc": ""
  }, {
    "modal-footer": _withCtx(({ ok, cancel }) => [
      _createVNode(_component_b_btn, {
        onClick: ok,
        variant: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`${viewModel.okButtonText}`)), 1)
        ]),
        _: 2
      }, 1032, ["onClick"]),
      _createVNode(_component_b_btn, { onClick: cancel }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`${viewModel.cancelButtonText}`)), 1)
        ]),
        _: 2
      }, 1032, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (viewModel.showCheckOption)
          ? (_openBlock(), _createBlock(_component_b_form_group, { key: 0 }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("p", _hoisted_1, null, 512), [
                  [_directive_dompurify_html, viewModel.question]
                ]),
                _createVNode(_component_b_checkbox, {
                  class: "text-nowrap",
                  modelValue: viewModel.checkOption,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((viewModel.checkOption) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("messageNotShowAgain")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_2, null, 512)), [
              [_directive_dompurify_html, viewModel.question]
            ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})